import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerBolletteVersamentoModalComponent } from './worker-bollette-versamento-modal';

export const WorkerBolletteVersamentoModalModule: string = ng
    .module('worker-bollette-versamento-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerBolletteVersamentoModalComponent', WorkerBolletteVersamentoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-bollette-versamento-modal/worker-bollette-versamento-modal.module.ts